if ($('div').hasClass('mw_wp_form_confirm')) {
  $('.recruit-sec').hide();
  $('.outlineArea').find('.intro').hide();
  $('.outlineArea').find('.read').hide();
  $('.outlineArea').find('.confirm').fadeIn(0);
};
